import { css } from "@emotion/css";
import { theme } from "assets/theme";

export const ServiceItemStyle = css`
  width: 100%;
  border-bottom: 1px solid ${theme.colors.border.primary};
  backdrop-filter: blur(1.5px);
  padding: 20px 0px 20px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ServiceItemLeftStyle = css`
  width: 68%;
  @media (max-width: 768px) {
    width: 70%;
  }
`;

export const ServiceItemRightStyle = css`
  width: 32%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: auto;
  }
`;
export const ServiceItemTitleStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const ServiceIconStyle = {
  width: "24px",
  height: "24px",
  marginLeft: "8px",
};
export const GoogleOauthSectionStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: ${theme.colors.background.primary};
  height: 100px;
  max-width: 688px;
  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.1);
`;
export const OnboardingBtnSectionStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
`;
export const WarningIconStyle = {
  width: "24px",
  height: "24px",
  marginRight: "20px",
};
export const InfoItemStyle = css`
  width: 100%;
  border-radius: 16px;
  border: 1px solid ${theme.colors.border.primary};
  backdrop-filter: blur(1.5px);
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;
export const InfoItemTitleStyle = css`
  display: flex;
  flex-direction: column;
  width: 80%;
`;
export const InfoLeftItemStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const LearnMoreStyle = css`
  border-radius: 47.139px;
  background: ${theme.colors.accent.white};
  height: 24px;
  padding: 0px 16px;
  font-size: 12px;
  cursor: pointer;
  color: ${theme.colors.text.dark};
`;
